import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import generateId from './generateId';
import { updateHashProps, rewriteUserId } from '../general';
import { addDatasToSave, loadDbModel } from './workBackendSlice';
import { saveAllData, saveData, deleteData, SignUpPayload } from './dataBackend';

export type RelationUserImageDb = {
  userId: string;
  imageId: string;
}
const initial: RelationUserImageDb = {
  userId: '',
  imageId: ''
};

export type RelationUserImageDbHashType = {
  [key in string]: RelationUserImageDb;
}

export type RelationUserImageAddPayload = {
  id?: string;
} & RelationUserImageDb;
export type RelationUserImageUpdatePayload = {
  id: string;
} & { [P in keyof RelationUserImageDb]?: RelationUserImageDb[P] };

export type RelationUserImageDbState = {
  relationUserImages: RelationUserImageDbHashType;
}

export const generateRelationUserImageId = (): string => generateId('rui');
let initialState: RelationUserImageDbState = { relationUserImages: {} };
const key = 'relationUserImages';

const relationUserImageDbSlice = createSlice({
  name: 'relationUserImageDb',
  initialState,
  reducers: {
    initializeRelationUserImages(state: RelationUserImageDbState) {
      state.relationUserImages = {};
    },
    addRelationUserImage(state: RelationUserImageDbState, action: PayloadAction<RelationUserImageAddPayload>) {
      let { id, ...obj } = action.payload;
      if (!id) id = generateRelationUserImageId();
      state.relationUserImages[id] = obj;
      saveData(key, id, obj);
    },
    updateRelationUserImage(state: RelationUserImageDbState, action: PayloadAction<RelationUserImageUpdatePayload>) {
      const { id, ...obj } = action.payload;
      if (state.relationUserImages[id] === undefined) {
        console.log(`*** RelationUserImage not found: ${id}`);
      } else {
        const newData = { ...state.relationUserImages[id], ...obj };
        state.relationUserImages[id] = newData;
        saveData(key, id, newData);
      }
    },
    deleteRelationUserImage(state: RelationUserImageDbState, action: PayloadAction<RelationUserImageUpdatePayload>) {
      const id = action.payload.id;
      delete state.relationUserImages[id];
      deleteData(key, id);
    },
    saveRelationUserImages(state: RelationUserImageDbState) {
      saveAllData(key, state.relationUserImages);
    },
    signUpRelationUserImages(state: RelationUserImageDbState, action: PayloadAction<SignUpPayload>) {
      const values = rewriteUserId(state.relationUserImages, action.payload);
      addDatasToSave(key, values);
    }
  },
  extraReducers: (builder) => {
    builder.addCase(loadDbModel(key).fulfilled, (state: RelationUserImageDbState, action) => {
      const values = action.payload;
      const [changed, updatedValues] = updateHashProps(initial, values);
      state.relationUserImages = updatedValues;
      if (changed) saveAllData(key, state.relationUserImages);
    })
  }
})

export const { initializeRelationUserImages, addRelationUserImage, updateRelationUserImage, deleteRelationUserImage, saveRelationUserImages, signUpRelationUserImages } = relationUserImageDbSlice.actions;
export default relationUserImageDbSlice.reducer;
